/**
 * 404 Not Found Page
 */

import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '@/components/common/SEO';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <SEO title="Page Not Found" noindex />
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <p className="text-2xl text-gray-600 mb-4">Page not found</p>
        <p className="text-gray-500 mb-8 max-w-md">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-block bg-primary text-primary-foreground px-6 py-3 rounded-lg font-medium hover:brightness-105 transition shadow-md"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;

